import { Link } from 'react-router-dom';
import { BRAND_LOGO_URL } from '@/data/servicesData';

const CONTACT_EMAIL = 'services@blackline-cleaning.co.za';
const CONTACT_PHONE = '069 057 9693';

const FooterBrand = () => (
  <div>
    <img
      src={BRAND_LOGO_URL}
      alt="BLACKLINE CLEANING"
      data-testid="footer-logo"
      className="h-28 w-auto object-contain mb-4"
    />
    <p className="font-mono text-base text-zinc-400">
      Professional Exterior Cleaning Specialists
    </p>
  </div>
);

const FooterServiceArea = () => (
  <div>
    <h4 className="font-oswald text-base uppercase font-bold text-white mb-4">Service Area</h4>
    <div className="space-y-2 font-mono text-base text-zinc-400">
      <p className="text-blackline-accent font-bold">Johannesburg</p>
      <p className="text-blackline-accent font-bold">Sandton</p>
      <p className="text-zinc-500">& Surrounding Areas</p>
    </div>
  </div>
);

const FooterLinks = () => (
  <div>
    <h4 className="font-oswald text-base uppercase font-bold text-white mb-4">Quick Links</h4>
    <div className="space-y-2 font-mono text-base text-zinc-400">
      <Link to="/services" className="block hover:text-white transition-colors">Services</Link>
      <Link to="/about" className="block hover:text-white transition-colors">About</Link>
      <Link to="/contact" className="block hover:text-white transition-colors">Contact</Link>
    </div>
  </div>
);

const FooterContacts = () => (
  <div>
    <h4 className="font-oswald text-base uppercase font-bold text-white mb-4">Contact Us</h4>
    <div className="space-y-3 font-mono text-base">
      <div>
        <p className="text-zinc-500 uppercase mb-1">Phone</p>
        <a href="tel:0690579693" className="text-white hover:text-blackline-accent transition-colors block">
          {CONTACT_PHONE}
        </a>
      </div>
      <div>
        <p className="text-zinc-500 uppercase mb-1">WhatsApp</p>
        <a
          href="https://wa.me/27690579693"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="text-white hover:text-blackline-accent transition-colors block"
        >
          WhatsApp: {CONTACT_PHONE}
        </a>
      </div>
      <div>
        <p className="text-zinc-500 uppercase mb-1">Email</p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-white hover:text-blackline-accent transition-colors block break-all">
          {CONTACT_EMAIL}
        </a>
      </div>
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-blackline-border bg-blackline-bg/50 py-12" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <FooterBrand />
          <FooterServiceArea />
          <FooterLinks />
          <FooterContacts />
        </div>
        
        <div className="mt-12 pt-8 border-t border-blackline-border">
          <p className="font-mono text-base text-zinc-600 text-center">
            © {new Date().getFullYear()} BLACKLINE CLEANING. Servicing Johannesburg & Sandton Areas. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}